import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import { config, reactShell } from 'angular/utils/config';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpExport
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * Generate CSV/PDF export links for reporting overviews.
     *
     * @author frbomke.btc
     */
    angular.module('app').directive('pkpExport', pkpExport);

    function pkpExport(utilService: UtilService) {
        return {
            restrict: 'E',
            scope: {
                type: '@',
                params: '=',
                allowCsv: '<',
                allowPdf: '<',
                report: '@'
            },
            template: require('app/_directives/pkp-export.directive.html'),
            link: function (scope) {
                scope.assembleFileExportParams = assembleFileExportParams;
                scope.REST_CONTEXT = config.monolithApi;
                scope.stageConfig = config;
                scope.reactShell = reactShell;

                if (angular.isUndefined(scope.allowCsv)) {
                    scope.allowCsv = true;
                }

                if (angular.isUndefined(scope.allowPdf)) {
                    scope.allowPdf = true;
                }
            }
        };

        function assembleFileExportParams(params) {
            return utilService.objectLiteralToQueryParamString(params);
        }
    }
})();
